import React, { useState } from "react";
import InvoiceItemTableRow from "./InvoiceItemTableRow";
import spLogo from "assets/brand/logo2_dark.png";

const InvoiceTableRow = (props) => {

    const [showDetails, setShowDetails] = useState(false);

    const toggleDetails = () => {
        setShowDetails(!showDetails);
    }

    const detailsTable = props.sites.map(data => <InvoiceItemTableRow key={data.app_id} {...data} details={props.raw.filter(d => d.business_app_id === data.app_id)}></InvoiceItemTableRow>);

    return (<>
        <tr className="domain-row" onClick={() => toggleDetails()}>
          <td>
            {new Date(props.period_end).toLocaleString('default', { month: 'long' })} {props.period_end.split("-")[0]}
          </td>
          <td className="text-right">${props.total.toFixed(2)}</td>
        </tr>
        {showDetails ? 
            <tr className="domain-row-detail">
                <td className="m-0 p-0" colSpan="4">
                    <table className="m-0 p-0" style={{width:"100%"}}>
                        <tbody>
                            {detailsTable}
                            <tr className="domain-row">
                                <td style={{width: "60px"}}>
                                    <div className="flag">
                                        <img style={{height:"30px"}} src={spLogo} alt="streempay logo" />
                                    </div>
                                </td>
                                <td>StreemPay Fee</td>
                                <td style={{width: "60px"}} className="text-center">&nbsp;</td>
                                <td style={{width: "60px"}} className="text-right">${props.streempay_fee.toFixed(2)}</td>
                            </tr>
                        </tbody>
                    </table>
               </td>
        </tr> : <></> }
        
    </>);

}
export default InvoiceTableRow;

